import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './views/layout/layout.module';
import { AuthGuard } from './core/guard/auth.guard';
import { AppComponent } from './app.component';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AlertService } from './services/alert.service';
import { AuthenticationService } from './services/authentication.service';
import { DataService } from './services/data.service';
import { HttpInterceptorService } from './services/interceptor.service';
import { UserSessionService } from './services/usersession.service';
import { RoleService } from './services/role.service';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { NavigationService } from './services/navigation.service';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LightboxModule } from 'ngx-lightbox';
import { UserIdleModule } from 'angular-user-idle';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule as MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { DirectivesModule } from './views/layout/directives/directives.module';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatSelectFilterModule } from 'src/app/shared/mat-select-filter/mat-select-filter.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgApexchartsModule } from 'ng-apexcharts'
// import { EmployeedetailsComponent } from './views/pages/employeedetails/employeedetails.component';
import { LoaderModule } from './views/layout/loader/loader.module';
// import { GrievanceComponent } from './views/pages/grievance/grievance.component';
import { MatCardModule as MatCardModule } from '@angular/material/card';
import { ReportsComponent } from './views/pages/reports/reports.component';
import { LocationfacilitiesComponent } from './views/pages/locationfacilities/locationfacilities.component';
import { BvgComponent } from './views/pages/bvg/bvg.component';
import { DynamicdialogComponent } from './views/pages/dynamicdialog/dynamicdialog.component';
// import { AngularEditorModule } from '@kolkov/angular-editor';


@NgModule({ declarations: [
        AppComponent,
        ErrorPageComponent,
        ReportsComponent,
        LocationfacilitiesComponent,
        BvgComponent,
        DynamicdialogComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatInputModule,
        MatFormFieldModule,
        MatDialogModule,
        DirectivesModule,
        MatSelectModule,
        MatSelectFilterModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatTooltipModule,
        NgbDropdownModule,
        UiSwitchModule,
        MatCardModule,
        MatButtonModule,
        // AngularEditorModule,
        NgApexchartsModule,
        LoaderModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-top-right',
            preventDuplicates: true
        }),
        // NgHttpLoaderModule.forRoot(),
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        TranslateModule.forRoot(),
        LightboxModule,
        UserIdleModule.forRoot({ idle: 1200, timeout: 20, ping: 30 }),
        NgbModule], providers: [
        AuthGuard,
        NavigationService,
        {
            provide: HIGHLIGHT_OPTIONS,
            useValue: {
                coreLibraryLoader: () => import('highlight.js/lib/core'),
                languages: {
                    xml: () => import('highlight.js/lib/languages/xml'),
                    typescript: () => import('highlight.js/lib/languages/typescript'),
                    scss: () => import('highlight.js/lib/languages/scss'),
                }
            }
        },
        DataService,
        AuthenticationService,
        AlertService,
        RoleService,
        UserSessionService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideTranslateHttpLoader(),
    ] })
export class AppModule { }
